SpinnerView = require '../../../spinner/frontend/views/spinner'

module.exports = SpinnerGroup =
  spinners: {}

  addSpinner: (name, options) ->
    @spinners[name] = (new SpinnerView(options)).render()

  removeSpinner: (name) ->
    @spinners[name]?.remove()
    delete @spinners[name]

  start: (name, options) ->
    spinner = @spinners[name] ? @addSpinner(name, options).render()
    spinner?.start()

  stop: (name, options) ->
    return @removeSpinner(name) if options?.remove
    return unless (spinner = @spinners[name])?.isRunning()
    spinner.stop()
